<template>
  <div id="app">
    <div v-if="isWorkspace" class="workspace">
      <button v-if="menuOpen" class="nav-scrim" aria-label="关闭导航" @click="menuOpen = false"></button>
      <aside class="workspace-sidebar" :class="{ 'is-open': menuOpen }" :inert="isMobile && !menuOpen ? '' : null" :aria-hidden="isMobile && !menuOpen ? 'true' : null">
        <router-link :to="isGuest ? '/file/shared' : '/'" class="brand">
          <span class="brand-mark"><i class="el-icon-folder-opened"></i></span>
          <span>文件空间<small>FILE SPACE</small></span>
        </router-link>
        <div class="nav-label">工作空间</div>
        <nav aria-label="主导航">
          <router-link v-for="item in navigation" :key="item.path" :to="item.path" exact class="nav-item">
            <i :class="item.icon"></i><span>{{ item.label }}</span>
            <i class="el-icon-arrow-right nav-arrow"></i>
          </router-link>
        </nav>
        <div class="sidebar-note"><i class="el-icon-connection"></i><strong>让文件流动起来</strong><p>整理你的文件，分享每一个好想法。</p></div>
        <div class="sidebar-bottom">
          <router-link v-if="!isGuest" to="/user/center" class="nav-item"><i class="el-icon-user"></i><span>个人中心</span></router-link>
          <button class="nav-item logout-nav" @click="signOut"><i class="el-icon-switch-button"></i><span>退出登录</span></button>
        </div>
      </aside>
      <div class="workspace-main">
        <header class="workspace-topbar">
          <div class="topbar-location">
            <button class="menu-toggle" aria-label="打开导航" :aria-expanded="String(menuOpen)" @click="menuOpen = !menuOpen"><i class="el-icon-s-fold"></i></button>
            <span class="breadcrumb-root">工作空间</span><i class="el-icon-arrow-right breadcrumb-chevron"></i><strong>{{ pageTitle }}</strong>
          </div>
          <div class="topbar-actions">
            <span class="workspace-date">{{ today }}</span>
            <router-link v-if="!isGuest" to="/file/upload" class="quick-upload"><i class="el-icon-plus"></i> 上传文件</router-link>
            <router-link :to="isGuest ? '/file/shared' : '/user/center'" class="account-avatar" :aria-label="isGuest ? '访客工作空间' : '个人中心'">{{ isGuest ? '访' : '我' }}</router-link>
          </div>
        </header>
        <main class="workspace-content"><router-view /></main>
        <footer class="workspace-footer"><span>文件空间 · 让整理与分享更简单</span><span>随时访问，轻松协作</span></footer>
      </div>
    </div>
    <router-view v-else />
  </div>
</template>

<script>
import { logout } from '@/api/auth'
import { removeToken, getRole } from '@/utils/auth'

const pages = {
  Home: '概览', MyFiles: '我的文件', FileUpload: '上传文件',
  SharedFiles: '共享中心', RecycleBin: '回收站', RecentViewed: '最近浏览',
  UserCenter: '个人中心', UserManagement: '用户管理'
}

export default {
  name: 'App',
  data() { return { menuOpen: false, isMobile: false } },
  computed: {
    isWorkspace() { return !!this.$route.meta.requiresAuth },
    isGuest() { return this.isWorkspace && getRole() === 'guest' },
    pageTitle() { return pages[this.$route.name] || '工作空间' },
    today() { return new Date().toLocaleDateString('zh-CN', { month: 'long', day: 'numeric', weekday: 'long' }) },
    navigation() {
      const items = [
        { path: '/', label: '空间概览', icon: 'el-icon-menu' },
        { path: '/file/my-files', label: '我的文件', icon: 'el-icon-folder' },
        { path: '/file/shared', label: '共享中心', icon: 'el-icon-connection' },
        { path: '/file/upload', label: '上传文件', icon: 'el-icon-upload2' },
        { path: '/file/recycle', label: '回收站', icon: 'el-icon-delete' }
      ]
      if (this.isGuest) return items.filter(item => item.path === '/file/shared')
      if ((getRole() || '').includes('ROLE_ADMIN')) items.push({ path: '/admin/user', label: '用户管理', icon: 'el-icon-user-solid' })
      return items
    }
  },
  watch: { '$route.path'() { this.menuOpen = false } },
  mounted() {
    this.updateViewport()
    window.addEventListener('keydown', this.closeOnEscape)
    window.addEventListener('resize', this.updateViewport)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.closeOnEscape)
    window.removeEventListener('resize', this.updateViewport)
  },
  methods: {
    closeOnEscape(event) { if (event.key === 'Escape') this.menuOpen = false },
    updateViewport() { this.isMobile = window.innerWidth <= 800 },
    async signOut() {
      try { await this.$confirm('退出后需要重新登录才能访问文件。', '退出登录', { confirmButtonText: '退出', cancelButtonText: '取消', type: 'warning' }) }
      catch (_) { return }
      try { await logout() }
      catch (_) { /* 服务不可用时仍允许本地退出。 */ }
      removeToken()
      localStorage.removeItem('roles')
      this.$router.replace('/login')
    }
  }
}
</script>
